import styled from 'styled-components';

export const Container = styled.footer<{
  $addPadding: boolean;
  $fixed?: boolean;
}>`
  width: 100%;
  grid-area: footer;
  margin-top: auto;
  position: relative;
  top: auto;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.layers.footer};
  background-color: ${({ theme }) => theme.colors.neutral.lavenderLight};

  @media ${({ theme }) => theme.queries.minTablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
    right: 0;
    z-index: ${({ theme }) => theme.layers.footer};
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    position: ${({ $fixed }) => ($fixed ? 'fixed' : 'sticky')};
    left: ${({ $addPadding }) => ($addPadding ? '80px' : '0')};
    width: ${({ $addPadding }) => ($addPadding ? 'calc(100% - 80px)' : '100%')};
  }
`;

export const Content = styled.div`
  margin: 12px 32px 12px 32px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-direction: column;
  gap: 0;
  justify-content: space-between;
  padding: 24px 0px 48px 0px;
  margin: 0;

  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
    justify-content: flex-start;
    padding: 0;

    flex-wrap: nowrap;
    gap: 8px;
    padding: 12px 16px;
    > * {
      min-width: 0;
      flex-shrink: 1;
    }
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    padding: 12px 32px 12px 32px;
  }

  @media ${({ theme }) => theme.queries.mobile} {
    flex-direction: column;
    align-items: center;
    gap: 0;
    justify-content: space-between;
    padding: 24px 0px 48px 0px;
  }
`;

export const LegalContainer = styled.div`
  margin-top: 32px;
`;
